// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".h7xWtkLKQ0usKLBf6\\+j62A\\=\\={grid-template-areas:\"current-title new-title\" \"current-text1 new-text1\" \"current-text2 new-text2\" \"current-text3 new-text3\"}.q9m-5fGRhBNbTn7oacBttg\\=\\={grid-area:current-title}.I67aUGxZSKjrek5ROFaH7w\\=\\={grid-area:current-text1}.mtf7FVPVVaUdtWukRnY8iw\\=\\={grid-area:current-text2}.bQvK82jXQgdKLX2ka\\+MYXw\\=\\={grid-area:current-text3}.IKW9KqkUG6gslS5GsCzq6A\\=\\={grid-area:new-title}.nP9aFtQ-8txPb8vSOhqvAA\\=\\={grid-area:new-text1}.PG-ShO6TYirJT1TLS6ii-A\\=\\={grid-area:new-text2}.yWz2GUkwZ85iVrT4yu1MOQ\\=\\={grid-area:new-text3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridTemplateArea": "h7xWtkLKQ0usKLBf6+j62A==",
	"gridAreaCurrentTitle": "q9m-5fGRhBNbTn7oacBttg==",
	"gridAreaCurrentText1": "I67aUGxZSKjrek5ROFaH7w==",
	"gridAreaCurrentText2": "mtf7FVPVVaUdtWukRnY8iw==",
	"gridAreaCurrentText3": "bQvK82jXQgdKLX2ka+MYXw==",
	"gridAreaNewTitle": "IKW9KqkUG6gslS5GsCzq6A==",
	"gridAreaNewText1": "nP9aFtQ-8txPb8vSOhqvAA==",
	"gridAreaNewText2": "PG-ShO6TYirJT1TLS6ii-A==",
	"gridAreaNewText3": "yWz2GUkwZ85iVrT4yu1MOQ=="
};
module.exports = ___CSS_LOADER_EXPORT___;
